import { SelectOption } from "../../components/dropdown/Dropdown";
import { ActionLinkConfig } from "../../components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";
import { ACTION_KEY, APP_ROUTES, FILTER_KEY, endpoints } from "../../config";

export const nestedEndpointConfig = {
  programmesIDs:
    endpoints.projectmanagement.nestedPages.documents.search.programmes,
  projectsID: endpoints.projectmanagement.nestedPages.documents.search.projects,
};

export const endpointConfig = {
  sitesIds: endpoints.projects.search.sites,
  clientCompanyIds: endpoints.projects.search.clientCompany,
};
// TODO - UpdateConfig as modules are added
export const linkConfig: ActionLinkConfig = {
  projectsIds: {
    text: "View project",
    permissionKey: "view",
    location: APP_ROUTES.projects,
  },
  programmesIds: {
    text: "View programme",
    permissionKey: "view",
    location: "/",
  },
};
// TODO - UpdateConfig as modules are added
export const actionLinkTextConfig = {
  projectsIds: {
    text: "Add new project",
    permissionKey: "create",
    location: APP_ROUTES.projects,
  },
  programmeIds: {
    text: "Add new programme",
    permissionKey: "create",
    location: "/",
  },
};

export const onLinkClick = <T,>(field: keyof T, option: SelectOption) => {
  let filterString = "";
  let route = "";

  // console.log("onLinkClick config field: ", field);

  // TODO - UpdateConfig - Update cases for modules not built yet
  switch (field) {
    case "projectsIds":
      filterString = `Projects__Id EQ (${option.value})`;
      route = APP_ROUTES.projects;
      break;
    case "programmesIds":
      filterString = `Programmes__Id EQ (${option.value})`;
      route = "";
      break;
    default:
      return;
  }

  window.localStorage.setItem(FILTER_KEY, filterString);
  window.open(route, "_blank", "noreferrer");
};
export const onActionLinkClick = <T,>(field: keyof T) => {
  let action = "";
  let route = "";

  // TODO - UpdateConfig - Update cases for modules not built yet
  switch (field) {
    case "projectsIds":
      route = APP_ROUTES.projects;
      action = "CREATE";
      break;
    case "programmesIds":
      route = "";
      action = "CREATE";
      break;
    default:
      return;
  }

  window.localStorage.setItem(ACTION_KEY, action);
  window.open(route, "_blank", "noreferrer");
};
